import { useKakaoLoader as useKakaoLoaderOrigin } from 'react-kakao-maps-sdk';

export default function useKakaoLoader() {
  useKakaoLoaderOrigin({
    appkey: '3255490652dd58f51a4a3193ebf3ada5',
    libraries: ['clusterer', 'services'],
  });
}
